//  These are set up front to improve the speed of transforming lots of dates
let dateFunctions = ["FullYear", "Month", "Date", "Hours", "Minutes", "Seconds", "Milliseconds"]
    .map(p => ({
        local: Date.prototype[`get${p}`],
        utc: Date.prototype[`getUTC${p}`],
    }))

let localDateFns = dateFunctions.map(o => o.local)
let utcDateFns = dateFunctions.map(o => o.utc)

//  This will be set once at page load for performance,
//      so if the user changes their timezone they'd have to refresh the page before it changes anything
export let timezoneOffsetTicks = new Date().getTimezoneOffset()

export function dateParts(date, getUTC) {
    // Use instanceof because Vue may create a Date wrapper function making a direct equality check fail
    if (!date || !(date instanceof Date)) return

    let [Y, M, D, h, m, s, ms] = (getUTC ? utcDateFns : localDateFns).map(fn => fn.apply(date))
    let [MM, DD, hh, mm, ss] = [M + 1, D, h, m, s].map(n => (n < 10) ? `0${n}` : n)

    return { YYYY: `${Y}`, MM, DD, hh, mm, ss, ms: `00${ms}`.slice(-3) }
}

export function toDate(date, getUTC) {
    if (date instanceof Date) return date
    if (date) {
        if (!getUTC) {
            // Date will be in local browser timezone when YYYY-MM-DD string has any of these suffix chars: !@#$%&*(=/?<>"';:,. or a space
            date = new Date(date + ' ')
            if (!isNaN(date)) return date
        }

        return new Date(date)
    }
}

export function isoDate(date, getUTC) {
    let parts = dateParts(date, getUTC)
    if (parts) {
        let { YYYY, MM, DD } = parts
        return `${YYYY}-${MM}-${DD}`
    }
}

export function isoString(date, getUTC) {
    let parts = dateParts(date, getUTC)
    if (parts) {
        let { YYYY, MM, DD, hh, mm, ss, ms } = parts
        return `${YYYY}-${MM}-${DD}T${hh}:${mm}:${ss}.${ms}`
    }
}